var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"btn",class:[
    _vm.getClass,
    {
      'is-full': _vm.block
    }
  ]},'component',_vm.$attrs,false),[(_vm.spinner)?_c('b-loading',{attrs:{"is-full-page":false},model:{value:(_vm.isLoading),callback:function ($$v) {_vm.isLoading=$$v},expression:"isLoading"}}):_vm._e(),_c('span',{class:{ 'is-invisible': _vm.spinner }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }